import {Stack} from "@mui/material";
import DotAds from "./DotAds";

function AdsTest() {
    return <Stack spacing={2} width='1800px' height='1000px'>
        <DotAds adSlot={1}/>
        <DotAds adSlot={2}/>
        <Stack direction='row' width='100%' spacing={2}>
            <DotAds adSlot={3}/>
            <DotAds adSlot={4}/>
        </Stack>
    </Stack>
}

export default AdsTest